export default "__VITE_ASSET__HLSaVBWi__"